import React from 'react';
import imageUrlBuilder from '@sanity/image-url';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import client from '../../client';
import ConditionalLazyLoad from '../conditional-lazy-load';

const builder = imageUrlBuilder(client);

const imageTheme = () => ({
  width: '100%',
  height: 'auto',
});
const StyledImg = styled('img')(imageTheme);
const StyledPicture = styled('picture')(imageTheme);

function CaptionedImage(props) {
  const {
    caption,
    image,
  } = props;
  if (image === undefined) return null;
  return (
    <div>
      <ConditionalLazyLoad shouldLazyLoad offset={1500}>
        <StyledPicture>
          <source srcSet={builder.image(image).format('webp').maxWidth(900).url()} media='(min-width: 960px)' />
          <source srcSet={builder.image(image).format('webp').maxWidth(600).url()} media='(min-width: 450px)' />
          <source srcSet={builder.image(image).format('webp').maxWidth(450).url()} />
          <StyledImg
            src={builder.image(image).maxWidth(900).url()}
            alt={(image || {}).alt}
          />
        </StyledPicture>
      </ConditionalLazyLoad>
      {caption && caption.length > 0 && (
        <Box textAlign='center' padding={2}>
          <Typography variant='body2' color='textSecondary'>{caption}</Typography>
        </Box>
      )}
    </div>
  );
}

export default CaptionedImage;
